import type { SupportedChainName } from "../../types/base"
import { isEvmAddress, validateAddress } from "../validateAddress"
import { isSupportedQrBitcoinAddress } from "./bitcoinAddress"

export type ChainDetection = SupportedChainName | "evm_ambiguous" | "unknown"

export function detectChainFromAddress(input: string): ChainDetection {
  const trimmed = input.trim()
  if (trimmed.length === 0) return "unknown"

  if (isEvmAddress(trimmed)) return "evm_ambiguous"

  if (isSupportedQrBitcoinAddress(trimmed)) return "bitcoin"
  if (validateAddress(trimmed, "solana")) return "solana"

  return "unknown"
}
